import React, { useEffect, useRef, useState } from "react";

const stats = [
  { label: "Años de experiencia", value: 20, suffix: "+" },
  { label: "Proyectos exitosos", value: 1500, suffix: "+" },
  { label: "Profesionales certificados", value: 100, suffix: "%" },
  { label: "Cobertura en Santander", value: 87, suffix: " municipios" },
];

function useCountUp(target, active, duration = 1500) {
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf;
    const start = performance.now();
    const tick = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setValue(Math.round(target * eased));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, active, duration]);
  return value;
}

function StatItem({ s, active }) {
  const v = useCountUp(s.value, active);
  return (
    <div data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-display font-bold tracking-tighter">
        <span className="text-5xl lg:text-7xl">{v}</span>
        <span className="text-[#ff6b00] text-xl sm:text-2xl lg:text-4xl">{s.suffix}</span>
      </div>
      <div className="text-xs uppercase tracking-[0.3em] text-[#a0aabf] mt-3">
        {s.label}
      </div>
    </div>
  );
}

export default function Stats() {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && setActive(true),
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      data-testid="stats-section"
      className="relative py-24 bg-[#12141a] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {stats.map((s) => (
            <StatItem key={s.label} s={s} active={active} />
          ))}
        </div>
      </div>
    </section>
  );
}
